var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-column"},[_c('div',{staticClass:"search-column__column"},[(_vm.staticOrReadonly)?_c('Icon',{staticClass:"icon-handle",attrs:{"iconName":"Drag"}}):_vm._e(),_c('p',{class:[
        'search-column__text',
        _vm.showStaticClass ? 'search-column--static' : '',
        !_vm.column.visibility && !_vm.column.selected
          ? 'search-column--disabled'
          : ''
      ]},[_vm._v(" "+_vm._s(_vm.column.lbl || _vm.column.label)+" ")])],1),(_vm.staticOrReadonly)?_c('div',{on:{"click":_vm.handleSelect}},[_c('Icon',{attrs:{"iconName":_vm.iconName,"iconColor":_vm.iconColor}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }